import {
  LOAD_VEHICLE_HONEYTOASTDOWNLOADFILE,
} from "./actions";

const initialState = {
  vehicleLists: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_VEHICLE_HONEYTOASTDOWNLOADFILE.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
      };
    default:
      return state;
  }
};
